module.exports = __webpack_public_path__ + "media/images/logo-calderon-bg-1faea6c1a3e0709ac26664ddb7130a0c.png";